import { useEffect, useState } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import ColumnGuide from "./components/ColumnGuide";
import LatestFeed from "./components/LatestFeed";
import Evidence from "./components/Evidence";
import Topics from "./components/Topics";
import Insights from "./components/Insights";
import Faq from "./components/Faq";
import About from "./components/About";
import ContactForm from "./components/ContactForm";
import Footer from "./components/Footer";

export default function Home() {
  const [activeCat, setActiveCat] = useState("all");
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const pickCategory = (slug: string) => setActiveCat(slug);

  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero onPickCategory={pickCategory} />
        <ColumnGuide onPickCategory={pickCategory} />
        <LatestFeed activeCat={activeCat} onCatChange={setActiveCat} />
        <Evidence />
        <Topics />
        <Insights />
        <Faq />
        <About />
        <ContactForm />
      </main>
      <Footer />

      {showTop ? (
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          aria-label="返回顶部"
          className="fixed bottom-6 right-5 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-600 text-background-50 shadow-soft transition hover:bg-primary-700 md:bottom-8 md:right-8"
        >
          <i className="ri-arrow-up-line text-lg" />
        </button>
      ) : null}
    </div>
  );
}